/**
 * Форматирует имя пользователя для компактного аватара.
 * Готовые инициалы API не разбирает повторно как одно слово.
 */

/** Возвращает не более двух заглавных букв из инициалов или полного имени. */
export function formatUserInitials(value, fallback = "—") {
  const normalized = String(value || "").trim();
  if (!normalized) return fallback;
  if (!normalized.includes(" ") && normalized.length <= 2) return normalized.toUpperCase();

  return normalized
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
